<script>
  import { _ } from 'svelte-i18n'
  import { modals, server_path, tag_to_remove, user_font_tags, flash_content, detected_fonts } from '../../stores'
  import { find, filter, flatMap, remove } from 'lodash'
  import { reloadTagedFonts, saveTag } from '../../services/tags'
  import axios from 'axios'
  import Button from '../../elements/Button.svelte'
  import FormError from '../../elements/FormError.svelte'
  import Modal from '../../elements/Modal.svelte'
  import ButtonGroup from '../../elements/ButtonGroup.svelte'

  let modal_id = 'removeTag'
  let button_busy = false
  let form_element
  let show_error = false

  $: tag_id = $tag_to_remove ? $tag_to_remove.tag_id : undefined
  $: font_id =  $tag_to_remove ? $tag_to_remove.font_id : undefined

  async function handleSubmit(event) {
    if (tag_id === undefined || font_id === undefined) { 
      console.warn('tag id or font id missing, cannot remove tag'); 
      return 
    }

    button_busy = true
    show_error = false

    try {
      // Get tag to remove from and font to remove
      const tagToRemoveFrom = find($user_font_tags, {'id': tag_id})
      const fontToRemove = find($detected_fonts, {'id': font_id})

      if (!tagToRemoveFrom || !fontToRemove) {
        throw new Error('Tag or font not found')
      }

      // Update font names string in tag
      const currentFontNames = tagToRemoveFrom.fonts.split('|-|')
      const updatedFontNames = currentFontNames
        .filter(name => name !== fontToRemove.postscript_name)
        .join('|-|')

      // Save to server
      const form_data = new FormData()
      form_data.append('tag_id', tag_id)
      form_data.append('fonts', updatedFontNames || ' ')
      
      const response = await saveTag(form_data)

      if (response.data === false) {
        show_error = true
      } else {
        reloadTagedFonts()
        modals.close()
        $flash_content = $_('flashes.userRemovedTag')
      }
    } catch (error) {
      console.error("Error removing tag:", error)
      show_error = true
    } finally {
      button_busy = false
    }
  }
  
</script>

<Modal id={modal_id}>
  <span slot="header">
    {@html $_('modals.removeTag.title', { values: { tag_name: find($user_font_tags, {'id': tag_id}).tag_name } })}
  </span>
  <span slot="content">
    <FormError bind:visible={show_error}>{$_('modals.deleteTag.deleteError')}</FormError>
    <form bind:this={form_element} on:submit|preventDefault="{handleSubmit}">
      <p>{$_('modals.removeTag.intro')}</p>
      <p class="warning">{$_('modals.removeTag.warning')}</p>
      <ButtonGroup mt={3}>
        <Button kind="delete" type="submit" busy={button_busy}>{$_('buttons.remove')}</Button>
        <Button kind="outline" on:click={() => modals.close()}>{$_('buttons.cancel')}</Button>
      </ButtonGroup>
    </form>
  </span>
</Modal>

<style>
  .warning { 
    color: var(--c-danger);
  }
</style>